import React from 'react';

const Logo = ({ size = 32, className = "" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      className={className}
      style={{ borderRadius: '8px', overflow: 'hidden' }}
    >
      <rect width="32" height="32" rx="8" fill="#6f4e37"/>
      <g transform="translate(4, 4)">
        <path d="M6 4v6a6 6 0 0 0 12 0V4" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <line x1="4" y1="20" x2="20" y2="20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  );
};

export default Logo;
